import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

const styles = {
  ...buttonStyle,
  wrapper: {
    padding: 20,
    backgroundColor: "#edf8fb",
    boxShadow: "inset 0px 35px 10px -30px rgba(0,0,0,0.05), inset 0px -35px 10px -30px rgba(0,0,0,0.05)"
  },
  bgSuccess: {
    backgroundColor: "#edfbee"
  },
  bgWarning: {
    backgroundColor: "#fbf3df"
  },
  table: {
    width: "100%",
    "& > tr > td:first-child": {
      fontWeight: "bold"
    },
    "& th": {
      textAlign: "left",
    },
    "& table": {
      background: "#f3fcff",
      border: "#a0eaea solid 2px",
      borderRadius: 3,
      margin: "10px 0",
      width: "100%",
      "& td, & th": {
        padding: "2px 10px"
      },
      "& th": {
        paddingTop: "4px",
      },
      "& td:last-child": {
        textAlign: "center"
      }
    }
  },
  modalCardTitle: {
    fontSize: "20px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  form: {
    backgroundColor: "red"
  }
};

export {
  styles
}
